// @ts-nocheck
import styled from 'styled-components';

export const CampaignsSettingsStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .campaignsSettings {
    &__selector {
      padding: 1rem;
      background-color: ${props => props.theme.white};
    }

    &__error {
      color: ${props => props.theme.reallyBadStatus};
    }
  }
`;
